var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{class:_vm.backgroundColor,attrs:{"dense":"","item-key":"id","headers":_vm.tableHeaders,"items":_vm.chartData,"footer-props":{
      showFirstLastPage: true,
    }},scopedSlots:_vm._u([{key:"item.valor",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.currency)+" "+_vm._s(_vm._f("formatCurrency")(item.valor,_vm.hideValues))+" ")]}},{key:"item.categoria",fn:function(ref){
    var item = ref.item;
return [_c('v-icon',{staticClass:"d-none d-sm-inline-block"},[_vm._v(_vm._s(item.categoria.icone))]),_vm._v(" "+_vm._s(item.categoria.nome)+" "),_c('v-icon',{staticClass:"d-sm-none"},[_vm._v(_vm._s(item.categoria.icone))])]}},{key:"item.data",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("formatDate")(item.data))+" ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }